import ApiService from "@/api/baseApi/api-service";
import {
  IGEtPickupMethods,
  IGetShippingMethods,
} from "./interfaces/delevery-management-interfaces";
import { Config } from "../../config";
import {
  ICartManageItemParams,
  IGetCart,
  IGetDeliveryBranches,
  IGetPaymentMethods,
  IPaymentResponse,
  IPostPaymentMethodAvailableResult,
  ISetPaymentMethodParams,
  ISubmitCheckoutResponse,
  PostPaymentMethodAvailable,
} from "./interfaces/cart-interfaces";
import axios from "axios";
import { UserLocation } from "./user-location-interface";
const paymentURL = "/payments/";
const subBaseURL = "/carts";
const URLs = {
  getCart: subBaseURL,
  clearCart: subBaseURL + "/clear",
  postAddItem: subBaseURL + "/items",
  putEditItem: subBaseURL + "/items/",
  deleteItem: subBaseURL + "/items/",
  getShippingMethods: subBaseURL + "/shipping-methods?area_id=",
  getPickupMethods: subBaseURL + "/pickup-methods",
  setShippingMethods: subBaseURL + "/shipping-methods",
  setPaymentMethods: subBaseURL + "/payment-methods",
  postCoupons: subBaseURL + "/coupons",
  deleteCoupons: subBaseURL + "/coupons",
  submitCheckout: subBaseURL + "/submit",
  getPaymentMethods: subBaseURL + "/payment-methods",
  getDeliveryBranches: "/delivery-branches",
  postPaymentMethodAvailable: subBaseURL + "/payment-method-available",

  refresh: subBaseURL + "/refresh",
};
class ApiCart extends ApiService {
  constructor(config: Config) {
    super({ ...config });
    this.headers = { ...config };
  }
  headers: Config;
  getCart = (): Promise<IGetCart> => {
    return this.get(URLs.getCart, {});
  };
  clearCart = (): Promise<IGetCart> => this.delete(URLs.clearCart, {});
  manageCartItem = (body: ICartManageItemParams): Promise<IGetCart> => {
    const { cartId } = body;
    delete body.cartId;
    if (cartId) return this.put(URLs.putEditItem + cartId, { ...body });
    else return this.post(URLs.postAddItem, { ...body });
  };
  removeCartItem = (id: number): Promise<IGetCart> =>
    this.delete(URLs.deleteItem + id, {});
  getShippingMethods = (areaId: string): Promise<IGetShippingMethods> =>
    this.get(URLs.getShippingMethods + areaId, {});
  getpickupMethods = (): Promise<IGEtPickupMethods> =>
    this.get(URLs.getPickupMethods, {});
  setShippingMethod = ({
    price_zone_id,
    shipping_method_id,
  }: {
    price_zone_id: number;
    shipping_method_id: number;
  }): Promise<IGetCart> =>
    this.post(URLs.setShippingMethods, {
      price_zone_id: price_zone_id,
      shipping_method_id: shipping_method_id,
    });

  setPaymentMethod = (params: ISetPaymentMethodParams): Promise<IGetCart> =>
    this.post(URLs.setPaymentMethods, { ...params });
  postCoupons = ({
    code,
    country_code,
  }: {
    code: string;
    country_code: string;
  }): Promise<IGetCart> => this.post(URLs.postCoupons, { code, country_code });
  deleteCoupons = (): Promise<IGetCart> => this.delete(URLs.deleteCoupons, {});
  submitCheckout = (body: any): Promise<ISubmitCheckoutResponse> =>
    this.post(URLs.submitCheckout, { ...body });

  getPayments = (track_id: string): Promise<IPaymentResponse> =>
    this.get(paymentURL + track_id, {});
  getPaymentMethods = (country_code: string): Promise<IGetPaymentMethods> =>
    this.get(
      URLs.getPaymentMethods,
      country_code ? { params: { country_code } } : {},
    );
  getDeliveryBranches = (
    address_id: number,
    area_id: number,
  ): Promise<IGetDeliveryBranches> =>
    this.get(URLs.getDeliveryBranches, { params: { address_id, area_id } });
  postPaymentMethodAvailable = (
    body: PostPaymentMethodAvailable,
  ): Promise<IPostPaymentMethodAvailableResult> =>
    this.post(URLs.postPaymentMethodAvailable, { ...body });

  refresh = ({ country_code }: { country_code: string }): Promise<IGetCart> =>
    this.post(URLs.refresh, { country_code });
}

export default ApiCart;

export const APIGetUserLocation = () =>
  axios
    .get("https://ipapi.co/json/")
    .then((response): UserLocation => response.data)
    .catch((_error) => {
      // console.error(error);
    });
